import { render, staticRenderFns } from "./SocialImageReadiness.vue?vue&type=template&id=c850f864&lang=pug&"
import script from "./SocialImageReadiness.vue?vue&type=script&lang=js&"
export * from "./SocialImageReadiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports